module.exports = __webpack_public_path__ + "img/ttncreateapp1.c145d90d.png";